// src/pages/Notifications.js
// The bell's target page: likes, remixes, comments, follows, new-bot alerts.
//   GET /notifications · POST /notifications/{id}/read · /read-all · DELETE /{id}

import { useEffect, useState } from "react";
import { notifications as notifApi } from "../api";

const ICONS = {
  drift_like: "♥",
  drift_comment: "💬",
  drift_remix: "⟳",
  new_bot: "✨",
  follow: "＋",
};

function timeAgo(iso) {
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return "just now";
  if (d < 3600) return `${Math.floor(d / 60)}m`;
  if (d < 86400) return `${Math.floor(d / 3600)}h`;
  return `${Math.floor(d / 86400)}d`;
}

export default function Notifications({ onUnread }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const d = await notifApi.list();
      setItems(d.notifications || []);
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const markAll = async () => {
    try {
      await notifApi.markAllRead();
      setItems((xs) => xs.map((n) => ({ ...n, read: true })));
      onUnread?.(0);
    } catch (_) {}
  };

  const readOne = async (n) => {
    if (n.read) return;
    try {
      await notifApi.markRead(n.id);
      setItems((xs) => xs.map((x) => (x.id === n.id ? { ...x, read: true } : x)));
      onUnread?.((c) => Math.max(0, (c || 1) - 1));
    } catch (_) {}
  };

  const remove = async (n) => {
    try {
      await notifApi.remove(n.id);
      setItems((xs) => xs.filter((x) => x.id !== n.id));
    } catch (_) {}
  };

  const unread = items.filter((n) => !n.read).length;

  return (
    <div className="page">
      <div className="page__head" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <h1>Notifications</h1>
          <p className="page__sub">{unread ? `${unread} unread` : "You're all caught up."}</p>
        </div>
        {unread > 0 && <button className="btn btn--ghost" onClick={markAll}>Mark all read</button>}
      </div>

      {err && <div className="form-error center">{err}</div>}

      {loading ? (
        <div className="empty">Loading…</div>
      ) : items.length === 0 ? (
        <div className="empty">No notifications yet.</div>
      ) : (
        <div className="notif-list">
          {items.map((n) => (
            <div key={n.id} className={`notif ${n.read ? "" : "notif--unread"}`} onClick={() => readOne(n)}>
              <span className="notif__icon">{ICONS[n.type] || "🔔"}</span>
              <div className="notif__body">
                <div className="notif__msg">{n.message}</div>
                <div className="notif__time">{timeAgo(n.created_at)}</div>
              </div>
              <button className="notif__x" onClick={(e) => { e.stopPropagation(); remove(n); }} aria-label="Dismiss">✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
